import { Link } from 'react-router-dom';
import { newsList } from '@/mocks/news';

export default function NewsSection() {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50">
      <div className="flex items-center justify-between border-b border-background-200 px-4 py-3">
        <div className="flex items-center gap-2">
          <i className="ri-newspaper-line w-4 h-4 flex items-center justify-center text-base text-primary-600" />
          <h2 className="font-heading text-base font-bold text-foreground-950">最新影视资讯</h2>
        </div>
        <span className="text-[11px] text-foreground-400">每日更新</span>
      </div>
      <ul className="divide-y divide-background-100">
        {newsList.slice(0, 6).map((news) => (
          <li key={news.id}>
            <Link to={`/detail/${news.relatedId}`} className="group flex flex-col gap-1.5 px-4 py-3 transition hover:bg-background-100/70 md:flex-row md:items-start md:gap-4">
              <div className="flex shrink-0 items-center gap-2 md:w-[124px] md:flex-col md:items-start md:gap-1">
                <span className="rounded bg-primary-100 px-1.5 py-0.5 text-[10px] font-medium text-primary-800">{news.category}</span>
                <span className="text-[11px] text-foreground-400">{news.date}</span>
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-[13px] font-medium text-foreground-900 transition group-hover:text-primary-700 md:text-sm">
                  {news.title}
                </h3>
                <p className="mt-1 line-clamp-2 text-[11px] leading-relaxed text-foreground-500 md:text-xs">{news.excerpt}</p>
              </div>
              <i className="ri-arrow-right-s-line hidden w-4 h-4 shrink-0 items-center justify-center self-center text-foreground-300 md:flex" />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}